// extracted by mini-css-extract-plugin
export default {"Nav":"App_Nav__3sd0P"};